import React, { Component } from 'react';
import config from '../../config';
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      visibilityClass: '',
    };
  }
  toggleMenu = value => {
    this.setState({ openMenu: value });
  };
  handleScroll = () => {
    const { visibilityClass } = this.state;
    if (window.pageYOffset > 300) {
      if (visibilityClass !== 'navbar-shrink') {
        this.setState({ visibilityClass: 'navbar-shrink' });
      }
    } else {
      if (visibilityClass === 'navbar-shrink') {
        this.setState({ visibilityClass: '' });
      }
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { openMenu, visibilityClass } = this.state;
    return (
      <nav
        className={`navbar navbar-expand-lg navbar-light fixed-top ${visibilityClass}`}
        id="postNav"
      >
        <div className="container post-nav">
          <a className="navbar-brand post-nav" href="/">
            {config.siteTitle}
          </a>
          <button
            onClick={_ => this.toggleMenu(!openMenu)}
            className={`navbar-toggler navbar-toggler-right ${
              openMenu ? '' : 'collapsed'
            }`}
            type="button"
            aria-controls="navbarResponsive"
            aria-expanded={openMenu}
            aria-label="Toggle navigation"
          >
            Menu
            <i className="fas fa-bars"></i>
          </button>
          <div
            className={`collapse post-nav navbar-collapse ${openMenu ? 'show' : ''}`}
            id="navbarResponsive"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                  <a className="nav-link" href="/dev">
                    Dev
                  </a>
              </li>

              <li className="nav-item">
                  <a className="nav-link" href="/design">
                    Design
                  </a>
              </li>

              <li className="nav-item">
                  <a className="nav-link" href="/music">
                    Music
                  </a>
              </li>
              <li className="nav-item">
                  <a className="nav-link" href="/downloads">
                    Downloads
                  </a>
              </li>
              <li className="nav-item">
                  <a className="nav-link" href="/projects">
                    Projects
                  </a>
              </li>
              <li className="nav-item">
                  <a className="nav-link" href="/about">
                    About
                  </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
